import * as microsoftTeams from "@microsoft/teams-js";

class AuthTokenProvider {
    constructor() {
        this._accessToken = null;
        this._expiresAtEpochSec = 0;
        this._refreshBufferSec = 300; // refresh 5 mins before expiry
        this._initPromise = null;
        this._acquirePromise = null;
        this._teamsInitialized = false;
    }

    async initialize() {
        if (this._teamsInitialized) return;
        if (this._initPromise) return this._initPromise;

        this._initPromise = (async () => {
            await microsoftTeams.app.initialize();
            this._teamsInitialized = true;
        })();

        return this._initPromise;
    }

    async getAccessToken(forceRefresh = false) {
        await this.initialize();

        if (!forceRefresh && this._isTokenUsable()) {
            return this._accessToken;
        }

        if (this._acquirePromise) {
            return this._acquirePromise;
        }

        this._acquirePromise = (async () => {
            const token = await microsoftTeams.authentication.getAuthToken();
            this._accessToken = token;
            this._expiresAtEpochSec = this._extractExp(token) || this._fallbackExp();
            return token;
        })();

        try {
            return await this._acquirePromise;
        } finally {
            this._acquirePromise = null;
        }
    }

    clear() {
        this._accessToken = null;
        this._expiresAtEpochSec = 0;
    }

    _isTokenUsable() {
        if (!this._accessToken || !this._expiresAtEpochSec) return false;
        const now = Math.floor(Date.now() / 1000);
        return (this._expiresAtEpochSec - now) > this._refreshBufferSec;
    }

    _extractExp(jwt) {
        try {
            const parts = jwt.split(".");
            if (parts.length < 2) return 0;
            const payload = JSON.parse(
                atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"))
            );
            return Number(payload.exp || 0);
        } catch {
            return 0;
        }
    }

    _fallbackExp() {
        // conservative fallback (50 min)
        return Math.floor(Date.now() / 1000) + (50 * 60);
    }
}

const authTokenProvider = new AuthTokenProvider();
export default authTokenProvider;